export default __webpack_public_path__ + "locales/ja-JP/DeleteProfileEverDialog.json?hash=04a4152b1890cef0d106202f184f2477";